import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Marketplace Insurance",
  shortName: "Marketplace Insurance",
  slug: "marketplace-insurance-tms",
  seoTitle:
    "Marketplace Insurance & TMS Coverage | Neuro Wellness TMS Centers of America",
  seoDescription:
    "Have a Health Insurance Marketplace plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your ACA plan in Coral Springs, FL.",
  seoKeywords:
    "Marketplace insurance TMS coverage, ACA TMS therapy, Healthcare.gov depression treatment Florida, Marketplace mental health benefits, Marketplace SAINT TMS",
  planType: "Health Insurance Marketplace plan (ACA / Healthcare.gov)",
  planRegion: "Florida and nationwide",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits as an essential health benefit, including mental health services",
  planSpecificIntro:
    "The Health Insurance Marketplace (Healthcare.gov) was established under the Affordable Care Act (ACA) to provide individuals and families with access to health insurance. All ACA-compliant plans include behavioral health benefits as one of the ten essential health benefits, which may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Because Marketplace plans come in different metal tiers — Bronze, Silver, Gold, and Platinum — and are offered by multiple insurance carriers, coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific carrier, plan tier, deductible, and network.",
  officialResourceUrl: "https://www.healthcare.gov/",
  officialResourceLabel: "Health Insurance Marketplace (Healthcare.gov)",
};

export const MarketplaceInsuranceHub = () => (
  <InsurancePageTemplate config={config} />
);
export default MarketplaceInsuranceHub;
